import { Tooltip } from '@mui/material';
import React from 'react';
import Wrapper from './styles/Wrapper';
import ColorButton from './styles/ColorButton';

type Props = {
  value: string;
  onChange: (value: string) => void;
};

const PRESET_COLORS = [
  { name: 'Красный', hex: 'FF0000' },
  { name: 'Оранжевый', hex: 'FF7F00' },
  { name: 'Жёлтый', hex: 'FFFF00' },
  { name: 'Зелёный', hex: '00FF00' },
  { name: 'Мятный', hex: '3EB489' },
  { name: 'Бирюзовый', hex: '008080' },
  { name: 'Голубой', hex: '00FFFF' },
  { name: 'Синий', hex: '0000FF' },
  { name: 'Индиго', hex: '4B0082' },
  { name: 'Фиолетовый', hex: '800080' },
  { name: 'Розовый', hex: 'dd62d3' },
  { name: 'Коричневый', hex: '995727' },
];

function PresetColors({ value, onChange }: Props) {
  return (
    <Wrapper>
      {PRESET_COLORS.map(({ name, hex }) => (
        <Tooltip key={hex} title={name} placement="top" arrow>
          <ColorButton
            hexColor={hex}
            aria-label={`Выбрать цвет ${name}`} // 👈 доступная метка
            onClick={() => onChange(hex)}
            isSelected={hex === value}
          />
        </Tooltip>
      ))}
    </Wrapper>
  );
}

export default PresetColors;
